import type { TableSemanticSchema } from './types';

export const BmcSchema: TableSemanticSchema = {
  id: 'bmc',
  name: 'Business Model Canvas',
  description:
    'Osterwalder 9-block canvas. Each block is a cell; items carry hypothesis status so a BMC can feed into an Assumption Map.',
  cells: [
    { id: 'key_partners', label: 'Key Partners' },
    { id: 'key_activities', label: 'Key Activities' },
    { id: 'key_resources', label: 'Key Resources' },
    { id: 'value_propositions', label: 'Value Propositions' },
    { id: 'customer_relationships', label: 'Customer Relationships' },
    { id: 'channels', label: 'Channels' },
    { id: 'customer_segments', label: 'Customer Segments' },
    { id: 'cost_structure', label: 'Cost Structure' },
    { id: 'revenue_streams', label: 'Revenue Streams' },
  ],
  itemFields: [
    { key: 'block', label: 'Block', kind: 'enum', required: true,
      options: [
        { value: 'key_partners', label: 'Key Partners' },
        { value: 'key_activities', label: 'Key Activities' },
        { value: 'key_resources', label: 'Key Resources' },
        { value: 'value_propositions', label: 'Value Propositions' },
        { value: 'customer_relationships', label: 'Customer Relationships' },
        { value: 'channels', label: 'Channels' },
        { value: 'customer_segments', label: 'Customer Segments' },
        { value: 'cost_structure', label: 'Cost Structure' },
        { value: 'revenue_streams', label: 'Revenue Streams' },
      ] },
    { key: 'hypothesisStatus', label: 'Hypothesis Status', kind: 'enum',
      options: [
        { value: 'unvalidated', label: 'Unvalidated' },
        { value: 'testing', label: 'Testing' },
        { value: 'validated', label: 'Validated' },
        { value: 'invalidated', label: 'Invalidated' },
      ] },
  ],
  renderingHints: { layout: 'grid' },
};
